
import React from "react";
import {transactionBG} from "../Const/TranscationCode";

const LabelTranscationBG=(props)=>{
    const filter=transactionBG.filter((item)=>item.key===props.value);
    if(filter.length==1){
        return <div className={"badge badge-light-" + (filter[0].color)}>{(filter[0].label)}</div>
    }   
    return ''
}
export default LabelTranscationBG;